<!-- Added multilist items -->
@if (added.length > 0) {
  <div class="multiSelect__activityRow">
    <span>
      <img [src]="EIconPath.CUSTOM_FIELD_MULTI_LIST_ACTIVITY" />
    </span>
    <div class="multiSelect__activityDescription">
      <span> {{ 'added' | ppTranslate }} </span>
      @for (value of added; track value; let last = $last) {
        <span class="multiSelect__highlight">
          {{ value }} @if (!last) {
          <span>, </span>
          }</span
          >
        }
        <span>
          {{ 'in' | ppTranslate }}
          <span class="multiSelect__highlight">{{ ppChange.label }}</span></span
          >
        </div>
      </div>
    }

    <!-- Removed multi list -->
    @if (removed.length > 0) {
      <div class="multiSelect__activityRow">
        <span>
          <img [src]="EIconPath.CUSTOM_FIELD_MULTI_LIST_ACTIVITY" />
        </span>
        <div class="multiSelect__activityDescription">
          <span> {{ 'removed' | ppTranslate }} </span>
          @for (value of removed; track value; let last = $last) {
            <span class="multiSelect__highlight">
              {{ value }} @if (!last) {
              <span>, </span>
            }
          </span>
        }
        <span>
          {{ 'in' | ppTranslate }}
          <span class="multiSelect__highlight">{{ ppChange.label }}</span></span
          >
        </div>
      </div>
    }
